import { keepPreviousData } from '@tanstack/react-query';
import type { TRPC } from './types';
import type { Locale } from '@/lib/enums/locale.enum';

export const accountKeys = {
  info: (trpc: TRPC) => trpc.account.info.pathKey(),
  monitoredCompanies: (trpc: TRPC) => trpc.account.monitoredCompanies.pathKey(),
  monitoredEvents: (trpc: TRPC) => trpc.account.monitoredEvents.pathKey(),
};

type InfoArgs = {
  trpc: TRPC;
  locale: Locale;
  enabled?: boolean;
};

export const infoQueryOptions = ({ trpc, locale, enabled = true }: InfoArgs) =>
  trpc.account.info.queryOptions(
    { locale },
    {
      enabled,
      staleTime: 0,
    },
  );

type MonitoredCompaniesArgs = {
  trpc: TRPC;
  locale: Locale;
  enabled?: boolean;
};

export const monitoredCompaniesQueryOptions = ({ trpc, locale, enabled = true }: MonitoredCompaniesArgs) =>
  trpc.account.monitoredCompanies.queryOptions(
    { locale },
    {
      enabled,
      staleTime: 60 * 1000,
    },
  );

type MonitoredEventsArgs = {
  trpc: TRPC;
  pageNumber: number;
  limit: number;
  locale: Locale;
  enabled?: boolean;
};

export const monitoredEventsQueryOptions = ({ trpc, pageNumber, limit, locale, enabled = true }: MonitoredEventsArgs) =>
  trpc.account.monitoredEvents.queryOptions(
    { pageNumber, limit, locale },
    {
      enabled,
      placeholderData: keepPreviousData,
      staleTime: 30 * 1000,
    },
  );
